import { useState } from "react";
import { Sparkles, ChevronDown } from "lucide-react";

export default function AboutSection({ settings }) {
  const [open, setOpen] = useState(false);
  const title = settings?.about_title || "About Us";
  const teaser = settings?.about_teaser || "A story behind every bottle.";
  const body = settings?.about_body || "";

  if (!body.trim() && !teaser.trim()) return null;

  return (
    <section
      id="about"
      data-testid="about-section"
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20"
    >
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.3em] text-[var(--accent-gold)] mb-3 flex items-center gap-2">
          <Sparkles size={14} /> The Story
        </div>
        <h2 className="font-headings text-3xl sm:text-4xl lg:text-5xl font-light text-[var(--text-primary)]">
          {title}
        </h2>
      </div>

      <button
        data-testid="about-clickbox"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="group w-full text-left bg-[var(--bg-surface)] border border-[var(--border-default)] hover:border-[var(--brand-gold)]/60 transition-colors p-6 sm:p-8"
      >
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            <p className="font-headings text-xl sm:text-2xl text-[var(--text-primary)] leading-snug">
              {teaser}
            </p>
            {!open && (
              <p className="mt-2 text-xs uppercase tracking-[0.25em] text-[var(--brand-gold)]">
                Tap to read more
              </p>
            )}
          </div>
          <ChevronDown
            size={22}
            className={`shrink-0 mt-1 text-[var(--brand-gold)] transition-transform duration-500 ${open ? "rotate-180" : ""}`}
          />
        </div>

        <div
          data-testid="about-body-wrap"
          className={`grid overflow-hidden transition-all duration-500 ease-out ${open ? "grid-rows-[1fr] opacity-100 mt-6" : "grid-rows-[0fr] opacity-0 mt-0"}`}
        >
          <div className="min-h-0">
            <div
              data-testid="about-body"
              className="text-sm sm:text-base text-[var(--text-secondary)] leading-relaxed whitespace-pre-line max-w-3xl"
            >
              {body}
            </div>
          </div>
        </div>
      </button>
    </section>
  );
}
